import styled from 'styled-components';
import {
  ButtonBase,
  PrimaryLink,
  BaseColumnWrap,
} from '../../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import Image from '@stencil/image';
import {headingSizes, textSizes} from '@stencil/build-theme';

export const MultiRoomModalOverLaySection = styled.section(
  props => `
    display:flex;
    width:50rem;
    background-color:#e1e7ee;
    border-radius:4px;
    padding:${props.theme.spacing.custom(12)};
    flex-direction:column;
    position:absolute;
    right: 81px;
    top: 10px;
    z-index:1;
    `,
);

export const OverlayHeaderDiv = styled.div(
  props => `
      width:100;
      display:flex;
      flex-directionrow;
      justify-content:space-between;
      padding-bottom:${props.theme.spacing.base};
      align-items:center;
      `,
);

export const HotelImage = styled(Image)(
  props => `
    width: 3.6rem;
    height: 3.6rem;
    border-radius:0.4rem;

    `,
);

export const RoomTypSpan = styled.span(
  props => `
    padding-left:${props.theme.spacing.base};
    font-size:${props.theme.font.custom(18)};
    font-weight: 600;
    text-align:left;
    `,
);

export const MainContentWrapper = styled.ul(
  props => `
    width:100%;
    display:flex;
    flex-direction:column;
    background-color:${props.theme.colors.goWhite.base};
    border-radius:${props.theme.misc.borderRadius.large};
    li{
        display:flex;
        flex-direction:row;
        border-bottom:1px solid ${props.theme.colors.ash.dark};
        padding:${props.theme.spacing.large} ${props.theme.spacing.custom(8)};
        &:last-child{
            border-bottom:none;
        }
    }
    `,
);

export const GuestListDiv = styled.div(
  props => `
    display:flex;
    flex-direction:row;
    justify-content: space-between;
    width:100%;

    `,
);

export const GuestListInnerWrapper = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    width:80%;
    justify-content:space-between;
    text-align:left;
    `,
);

export const GuestListInnerText = styled.strong`
  text-transform: capitalize;
`;

export const DoneBtn = styled(ButtonBase)(
  props => `
    border-radius:4px;
    width:20%;
    padding:${props.theme.spacing.small} ${props.theme.spacing.base};
    font-weight: 500;
    &:disabled{
      background-color: ${props.theme.colors.downriver.light};
      border:0.1rem solid ${props.theme.colors.downriver.light};
      cursor: not-allowed;
    }
  `,
);

export const HeaderTextSpan = styled.span`
  ${textSizes.BaseW3}
`;

export const HeaderAlertTextSpan = styled.span`
  ${textSizes.BaseW3}
  padding-left:${props => props.theme.spacing.small};
  color: ${props => props.theme.colors.goRed.base};
`;

export const PaxDetailsDiv = styled.div(
  props => `
    width:80%;
    display:flex;
    justify-content:space-between;
    align-items:center
    padding-right:${props.theme.spacing.base};
    `,
);

export const PaxAdditionDiv = styled.div(
  props => `
    width:20%;
    margin-left:10px;
    `,
);

export const AddBtn = styled.span`
  ${headingSizes.Base}
  width:100%;
  display: flex;
  padding: ${props => props.theme.spacing.small} ${props => props.theme.spacing.base};
  border: 1px solid ${props => props.theme.colors.ash.dark};
  border-radius: ${props => props.theme.misc.borderRadius.custom(20)};
  box-shadow: 0 0.8rem 0.6rem -0.6rem ${props => props.theme.colors.shadow.light};
  color: ${props => props.theme.colors.goBrandBlue.base};
  align-items: center;
  justify-content: center;
`;

export const UpgradeDowngradeBtn = styled.span`
  ${headingSizes.Base}
  width:100%;
  display: flex;
  padding: ${props => props.theme.spacing.small} ${props => props.theme.spacing.base};
  border: 1px solid ${props => props.theme.colors.ash.dark};
  border-radius: ${props => props.theme.misc.borderRadius.custom(20)};
  box-shadow: 0 0.8rem 0.6rem -0.6rem ${props => props.theme.colors.shadow.light};
  color: ${props => props.theme.colors.goBrandBlue.base};
  align-items: center;
  justify-content: space-around;
`;

export const TotalPaxCountPara = styled.p(
  props => `
    width:100%;
    padding-top: ${props.theme.spacing.custom(9)};
    `,
);

export const StrickedpriceSpan = styled.span(
  props => `
    text-decoration: line-through;
    color: ${props.theme.colors.downriver.medium};
    
    `,
);

export const OriginalpriceSpan = styled.span`
  ${textSizes.BaseW3}
`;

export const TaxpriceSpan = styled.span(
  props => `
    color: ${props.theme.colors.downriver.medium};    
  `,
);

export const PricingWrapper = styled(BaseColumnWrap)(
  props => `
    align-items:flex-end;
    
    `,
);

export const FlexItemCenter = styled.div(
  props => `
        display:flex;
        align-items: ${props.alignitem || 'center'};
        `,
);

export const FlexWrap = styled.div(
  props => `
        display:flex;
        `,
);
